/**
 * Auto-generated from @intelishs-group/schema-core v5.3.18
 * Source: recursoshumanosTypes — Recursos Humanos — RhCatalogosController (proxy local a los catalogos centrales SINAY)
 * Generated: 2026-10-28
 * Do not edit manually. Run: npm run generate:services
 */
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ApiBaseService } from './api-base.service';
import type {
  CatalogoItemDtoListResponseDto,
} from '@schemas/rh-catalogos';

@Injectable({ providedIn: 'root' })
export class RhCatalogosService extends ApiBaseService {
  private baseUrl = `${environment.BaseUrl}/RhCatalogos`;

  /** Catálogo de puestos (catálogo central `positions`). */
  async puestos() {
    return this.get<CatalogoItemDtoListResponseDto>(`${this.baseUrl}/puestos`);
  }

  /** Catálogo de bancos (catálogo central `banks`). */
  async bancos() {
    return this.get<CatalogoItemDtoListResponseDto>(`${this.baseUrl}/bancos`);
  }

  /** Catálogo de géneros (catálogo central `genders`). */
  async generos() {
    return this.get<CatalogoItemDtoListResponseDto>(`${this.baseUrl}/generos`);
  }

  /** Catálogo de estados civiles (catálogo central `marital-statuses`). */
  async estadosCiviles() {
    return this.get<CatalogoItemDtoListResponseDto>(`${this.baseUrl}/estados-civiles`);
  }

  /** Catálogo de periodos de pago (catálogo central `periodicities`). */
  async periodosPago() {
    return this.get<CatalogoItemDtoListResponseDto>(`${this.baseUrl}/periodos-pago`);
  }

  /** Catálogo de esquemas de pago (catálogo central `pay-schemes`). */
  async esquemasPago() {
    return this.get<CatalogoItemDtoListResponseDto>(`${this.baseUrl}/esquemas-pago`);
  }

  /** Catálogo de tipos de contrato (catálogo central `employment-contract-types`). */
  async tiposContrato() {
    return this.get<CatalogoItemDtoListResponseDto>(`${this.baseUrl}/tipos-contrato`);
  }

  /** Catálogo de nacionalidades (catálogo central `nationalities`). */
  async nacionalidades() {
    return this.get<CatalogoItemDtoListResponseDto>(`${this.baseUrl}/nacionalidades`);
  }

  /** Catálogo de estados de México (catálogo central `states-of-mexico`). */
  async estadosMx() {
    return this.get<CatalogoItemDtoListResponseDto>(`${this.baseUrl}/estados-mx`);
  }

  /** Catálogo de grados de estudios (catálogo central `education-levels`). */
  async gradosEstudios() {
    return this.get<CatalogoItemDtoListResponseDto>(`${this.baseUrl}/grados-estudios`);
  }

  /** Catálogo de parentescos para contactos de emergencia (catálogo central `relationships`). */
  async parentescos() {
    return this.get<CatalogoItemDtoListResponseDto>(`${this.baseUrl}/parentescos`);
  }

  /** Catálogo de empresas/pagadoras (catálogo central `companies` — URL provisional, pendiente de confirmar con el equipo de catálogos). */
  async empresas() {
    return this.get<CatalogoItemDtoListResponseDto>(`${this.baseUrl}/empresas`);
  }
}
